<template>
  <div class="nav-bar" v-if="showHeader">
    <img src="@/assets/image/图标-20.png" alt="" @click="back">
    <div class="title">{{title}}</div>
    <div class="blank"></div>
  </div>
  <div v-if="showHeader" class="placeholder" />
  <router-view />
</template>

<script>
import { defineComponent, onMounted, reactive, toRefs } from 'vue';
import { onBeforeRouteUpdate,
  // useRouter,
  useRoute } from "vue-router";

export default defineComponent({
  setup() {
    // const router = useRouter();
    const route = useRoute();
    const data = reactive({
      title: '',
      showHeader: true,
    })
    onBeforeRouteUpdate((to) => {
      data.showHeader = to.meta.showHeader;
      data.title = to.meta.title;
      document.title = to.meta.title;
    });
    onMounted(() => {
      data.showHeader = route.meta.showHeader;
      data.title = route.meta.title;
      document.title = route.meta.title;
    });
    const back = () => {
      // router.go(-1);
      window.history.go( -1 );
    };
    return {
      ...toRefs(data),
      back,
    };
  },
})
</script>

<style lang="scss" scoped>
.nav-bar {
  z-index: 2;
  position: fixed;
  top: 0;
  display: flex;
  height: 44px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eaeaea;
  justify-content: space-between;
  padding: 0 20.83px;
  background-color: #fff;
  .title {
    text-align: center;
    font: 16.67px bold;
  }
  img, .blank {
    width: 20.83px;
  }
}
.placeholder {
  height: 44px;
  width: 100%;
}
</style>
